// TEMP CORE-9199 remove after Oct 30
import { adminApiAxios } from '@/api'
import type { ShadowSessionResponse } from './shadowSession.types'

export const fetchShadowSession = async (
  userId: number
): Promise<ShadowSessionResponse> => {
  const response = await adminApiAxios.get<ShadowSessionResponse>(
    `/finances/api/v2/admin/temp_shadow_session/${userId}`
  )
  return response.data
}
